import { Lesson } from "@core/grades/types";
import { Offer } from "@core/offers/types";
import { PaymentMethod } from "@core/invoices/types";
import { createPortal } from "@design-system/utils/portals";
import { atom } from "@mongez/react-atom";
import { FawryInitRequestData } from "@core/checkout/types";

export const paymentPortal = createPortal("payment-portal");

type PaymentData = {
  lessons?: Lesson[];
  offers?: Offer[];
  paymentMethod?: PaymentMethod;
  checkoutData?: FawryInitRequestData;
  receipt?: File;
  state?: "idle" | "processing" | "success" | "error";
  code?: string;
  canSubmit?: boolean;
};

export const paymentAtom = atom<PaymentData>({
  key: "payment",
  default: {},
});
